import { initMap, equalCols } from '../functions';
// import { Waypoint } from 'waypoints'
// const Waypoint = require('waypoints/lib/noframework.waypoints');

$.fn.isInViewport = function() {
	var elementTop = $(this).offset().top;
	var elementBottom = elementTop + $(this).outerHeight();

	var viewportTop = $(window).scrollTop();
	var viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$( () => {

	//waypoint-element
	/*if($('.waypoint-box').length > 0) {
		$(".waypoint-box-wrapper").each(function() {
			if ($(this).find('.images-wrapper').length < 1) {
				$(this).prev().addClass('waypoint-element');
			}
		});
		if ($(window).width() > 768) {
			var elementArr = [];
			$(".waypoint-box-wrapper").each(function(index) {
				var hasImage = false;
				if ($(this).find('.images-wrapper').length > 0) {
					hasImage = true;
				}

				var element = this;
				elementArr[index] = new Waypoint.Inview({
					element: $(element).find('.waypoint-box'),
					enter: function(direction) {
						if (direction == 'down') {
							if (hasImage) {
								$(element).find('.waypoint-element').addClass('sticky-top');
							} else {
								$(element).prev('.waypoint-element').addClass('sticky-top');
							}
							$(this.element).addClass('active');
						}
					},
					exited: function(direction) {
						if (hasImage) {
							$(element).find('.waypoint-element').removeClass('sticky-top');
						} else {
							$(element).prev('.waypoint-element').removeClass('sticky-top');
						}
						$(this.element).removeClass('active');
					}
				});
			});
		}
	}*/

	// TITLE ANIMATE

	if($('.animated-title').length > 0) {
		let animatedTitle = new Movinwords({
			el: '.animated-title',
			transition: 'fadeIn',
			delay: 200,
			autostart: false,
			offset: 150
		});
		var inviewTitle = new Waypoint.Inview({
			element: $('.template-banner--default')[0],
			enter: function(direction) {
				animatedTitle.start();
			},
		})
	}

	// TITLE ANIMATE


	// HEADER DROPDPOWN
	/* This code is adding an event listener to all elements with the class "nav-item" and "has-submenu".
	When the mouse is over the element, it adds the class "open" to the element and removes the class
	"open" from its siblings. */
	$( ".nav-item.has-submenu" ).on( "click", function() {
		$( this ).toggleClass( "open" );
		$( this ).siblings().removeClass( "open" );
	} );

	/* This code adds a mouseup event listener to the entire document. When the user clicks the mouse
	button and then releases it, the function is triggered. */
	$(document).mouseup(function (e) {
		var container = $(".nav-item.has-submenu");
		if(!container.is(e.target) && 
		container.has(e.target).length === 0) {
			container.removeClass('open');
		}
	});
	// HEADER DROPDPOWN

	const players = Array.from(document.querySelectorAll('.js-player')).map((p) => new Plyr(p));

	// Add click event listener to each toggle element
    $('.link-share').on('click', function(event) {
        // Prevent the event from bubbling up to the document
        event.stopPropagation();

        // Remove active class from all elements
        $('.link-share').removeClass('active');

        // Add active class to the clicked element
        $(this).addClass('active');
    });

    // Add click event listener to the document
    $(document).on('click', function() {
        // Remove active class from all elements when clicking outside
        $('.link-share').removeClass('active');
    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/regular/general.js